import { Link } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper, 
  useTheme
} from '@mui/material';
import { 
  SentimentVeryDissatisfied as SadFaceIcon,
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import SEO from '../components/SEO';

const NotFound = () => {
  const theme = useTheme();
  
  return (
    <>
      <SEO 
        title="Page Not Found | Gravity Point Media" 
        description="The page you are looking for does not exist." 
      />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
          py: 4
        }}
      >
        <Container maxWidth="md">
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 6 },
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              textAlign: 'center'
            }}
          >
            <SadFaceIcon 
              sx={{ 
                fontSize: 100, 
                color: theme.palette.primary.main,
                mb: 2
              }} 
            />
            
            <Typography
              variant="h1"
              component="h1"
              gutterBottom
              sx={{
                fontSize: { xs: '4rem', sm: '6rem' },
                fontWeight: 700,
                background: 'linear-gradient(45deg, #1976d2, #2196f3)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                mb: 1
              }}
            >
              404
            </Typography>
            
            <Typography 
              variant="h4" 
              gutterBottom
              sx={{
                mb: 3,
                fontWeight: 600
              }}
            >
              Page Not Found
            </Typography>
            
            <Typography 
              variant="body1" 
              color="text.secondary"
              sx={{
                mb: 4,
                maxWidth: '600px',
                mx: 'auto'
              }}
            >
              The page you are looking for might have been removed, had its name changed, 
              or is temporarily unavailable. Please check the URL or navigate back to the dashboard.
            </Typography>
            
            <Box 
              sx={{ 
                display: 'flex', 
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 2
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<HomeIcon />}
                component={Link}
                to="/"
                sx={{
                  py: 1.5,
                  px: 3,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  background: 'linear-gradient(45deg, #1976d2, #2196f3)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #1565c0, #1976d2)',
                  }
                }}
              >
                Back to Home
              </Button>
              
              <Button
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<ArrowBackIcon />}
                onClick={() => window.history.go(-1)}
                sx={{
                  py: 1.5,
                  px: 3,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600
                }}
              >
                Go Back
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default NotFound;